import {Model} from './model';
import {Unserializer} from './serialization';

export class PaymentHistoryImport implements Model {
  success: boolean;
  invoiceId: number;
  invoiceNumber: string;
  referenceNumber: string;
  date: Date;
  amount: number;

  static copy(oldObj: PaymentHistoryImport): PaymentHistoryImport {
    const newObj = new PaymentHistoryImport();
    newObj.success = oldObj.success;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.invoiceNumber = oldObj.invoiceNumber;
    newObj.referenceNumber = oldObj.referenceNumber;
    newObj.date = Unserializer.date(oldObj.date);
    newObj.amount = oldObj.amount;
    return newObj;
  }

  public getPrimaryKey(): null {
    return null;
  }

  isNew(): boolean {
    return false;
  }

  clone(): PaymentHistoryImport {
    return PaymentHistoryImport.copy(this);
  }
}
